const FALLBACK_OPTIONS_BY_FIELD = {
  jobRemoteStatus: ['On-Site', 'Remote', 'Hybrid'],
  jobRecruitmentStatus: ['unread', 'partially fulfilled', 'fulfilled'],
  'experience.experienceRequiredUnit': ['Years', 'Months'],
  'contractDuration.unit': ['Days', 'Weeks', 'Months', 'Years'],
  noticePeriodUnit: ['Days', 'Weeks', 'Months'],
  'jobPayDetails.clientBudgetCurrency': ['$', 'USD', 'INR'],
  'jobPayDetails.clientBudgetUnit': ['Hour', 'Daily', 'Monthly', 'Yearly'],
  workAuthorisation: ['US Citizen', 'Green Card', 'H1B', 'OPT', 'CPT', 'L2 EAD', 'H4 EAD', 'Other'],
  // NOTE: `relocation` is a boolean CHECKBOX, not a Yes/No select — it must not
  // get fallback options, or the edit form renders a Yes/No control while the
  // add form shows a single checkbox. (The call site also guards checkbox
  // fields, so this is belt-and-braces.)
  source: ['LinkedIn', 'Referral', 'Dice', 'Indeed', 'Monster', 'Vendor', 'Other'],
};

export function getEditFormFallbackOptions(field = {}) {
  return FALLBACK_OPTIONS_BY_FIELD[field.field] ?? [];
}
